/* @flow strict */

/* eslint-disable camelcase */
import * as React from 'react';
import DataTable from 'react-data-table-component';
import Loader from '/client/src/components/Loader';

type PropsType = {
  eventId: number | string
};

const customStyles = {
  headCells: {
    style: {
      fontWeight: 700,
      fontSize: '1rem'
    }
  }
};

let mock = {
  columns: []
};

const EventPageDetailDicountCodesURLs = ({ eventId }: PropsType): React.Element<'div'> => {
  const [discountsUrl, setDiscountsUrl] = React.useState([]);

  try {
    mock = require('./tableHeaders/urls.js');
  } catch (e) {
    console.warn('File "./tableHeaders/index.js" doesn\'t exist');
  }

  const handleLoaded = React.useCallback(
    async (error: Error, response: any) => {
      if (!error) {
        try {
          setDiscountsUrl(_.get(response, 'data.result', []));
        } catch (e) {
          console.error('cant get discounts list');
        }
      }
    },
    []
  );

  return (
    <Loader
      url={`/api/v1/1/discounts/${eventId}/urls`}
      onLoaded={handleLoaded}
    >
      {!!_.size(discountsUrl) ?
        <DataTable
          columns={mock.columns()}
          data={discountsUrl}
          customStyles={customStyles}
          // Clicked
          pagination={_.size(discountsUrl) > 10}
          highlightOnHover
          responsive
          striped
          fixedHeader
          noHeader
          sortIcon={(): React.Element<typeof React.Fragment> => {
            return (
              <>
                <span className="-sort-desc" />
                <span className="-sort-asc" />
              </>
            );
          }}
        /> : <div className='panel-body'>
          Discount Urls not found
        </div>  }
    </Loader>
  );
};

export default EventPageDetailDicountCodesURLs;
